<template>
  <v-menu left bottom offset-y :disabled="!showMenu">
    <template v-slot:activator="{ on, attrs }">
      <div class="wrapper">
        <!-- primary button -->
        <v-btn
          v-bind="$attrs"
          :loading="loading"
          :disabled="disabled"
          :class="{
            'button-primary': showMenu,
            'px-2': true
          }"
          v-on="$listeners"
        >
          <slot />
        </v-btn>
        <!-- secondary button -->
        <!-- We do not want to show a loading-state here, so we will disabled it if the component is loading. -->
        <v-btn
          v-if="showMenu"
          v-bind="Object.assign({}, $attrs, attrs)"
          :disabled="loading || disabled"
          min-width="0"
          class="button-secondary px-2"
          v-on="on"
        >
          <v-icon small>$freshvue-dropdown</v-icon>
        </v-btn>
      </div>
    </template>

    <!-- menu -->
    <slot v-if="$slots.menu" name="menu" />
    <v-list v-else-if="showMenu">
      <v-list-item
        v-for="(item, index) in actions"
        :key="index"
        :to="item.to ? item.to : null"
        :href="item.href"
        :target="item.target"
        :disabled="item.loading || disabled || item.disabled"
        @click.stop="item.action ? item.action($event) : null"
      >
        <v-list-item-action v-if="item.icon">
          <v-icon small>{{ item.icon }}</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{ item.text }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import _ from 'lodash'
import {
  VMenu,
  VBtn,
  VIcon,
  VList,
  VListItem,
  VListItemAction,
  VListItemContent,
  VListItemTitle
} from 'vuetify/lib'

export default {
  name: 'SplitButton',

  components: {
    VMenu,
    VBtn,
    VIcon,
    VList,
    VListItem,
    VListItemAction,
    VListItemContent,
    VListItemTitle
  },
  inheritAttrs: false,

  props: {
    /*
      Possible Object for an action:
      {
        icon: '$action-send',
        text: 'E-Mail senden',
        action: this.onSendEmail,
        to: { name: 'home' },
        href: 'https://www.google.com/',
        target: '_blank', // only used if 'href' is set
        disabled: false,
        loading: false
      }
    */
    actions: {
      type: Array,
      required: false,
      default: null
    },

    loading: {
      type: Boolean,
      required: false,
      default: false
    },

    disabled: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  computed: {
    showMenu() {
      return _.get(this.actions, 'length') > 0 || this.$slots.menu
    }
  }
}
</script>

<style lang="scss" scoped>
.wrapper {
  display: inline-block;
}

.button-primary {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.button-secondary {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
</style>
